import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { NotificationViewDto } from '../models/notification-view-dto';
import { HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Pagination } from '../models/pagination.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private path = API_ENDPOINTS.NOTIFICATION;

  constructor(private apiProvider: ApiProviderService) {}

  public getCurrentNotifications(): Observable<{ content: NotificationViewDto[]; pagination: Pagination }> {
    return this.apiProvider.get<{ content: NotificationViewDto[]; pagination: Pagination }>(this.path).pipe(
      map((response: any) => ({
        content: (response.body.content || [])
          .map((val: any) => new NotificationViewDto(val))
          .sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()),
        pagination: new Pagination(response.body),
      }))
    );
  }

  public closedById(id: number): Observable<HttpResponse<NotificationViewDto>> {
    return this.apiProvider.get<NotificationViewDto>(API_ENDPOINTS.CLOSE_NOTIFICATION + id);
  }
}
